module.exports = __webpack_public_path__ + "img/mochaLogo.d359cf68.png";